import * as ko from "knockout";
import 'jquery';
import { ZIndexManager } from 'Core/Common/ZIndexManager';

export class AutoCompleteExtention {

    static Init() {
        ko.bindingHandlers.autoComplete = {
            init: (element, valueAccessor) => {
                let source = valueAccessor().source;
                if (source.length != 0){
                    this.InitAutocomplete(element, valueAccessor);
                }
            },

            update: (element, valueAccessor, allBindings, viewModel, bindingContext) => {
                let valueUnwrapped = ko.unwrap(valueAccessor());
                if (valueUnwrapped.source.length != 0){
                    this.InitAutocomplete(element, valueUnwrapped, true);
                }
            }
        };
    }

    private static InitAutocomplete(element, valueAccessor, update?: boolean){
        const OnSelect = update ? valueAccessor.onSelect : valueAccessor().onSelect;
        let source = update ? valueAccessor.source : valueAccessor().source;
        let options = update ? valueAccessor.options : valueAccessor().options;

        $(element).autocomplete({
            minLength: options && options.minLength ? options.minLength : null,
            autoFocus: options && options.autoFocus ? options.autoFocus : false,
            source: source,
            open: function(){
                $(this).autocomplete('widget').css({
                    'z-index': ZIndexManager.Instance.NextValue,
                    'max-width': $(this).outerWidth() + 'px'
                });
                return false;
            },
            select: function (event, ui) {
                OnSelect(ui.item);
            }
        });
        (($(element).autocomplete("instance")) as any)._renderMenu = function(ul: JQuery, items: any[]) {
            ul.removeClass("ui-menu ui-widget ui-widget-content ui-autocomplete ui-front");
            ul.addClass("selectize-dropdown sps-autocomplete-menu sps-scrollable-y");
            items.forEach(item => {
                this._renderItemData(ul, item);
            });
        };
        (($(element).autocomplete('instance')) as any)._renderItem = function(ul: JQuery, item: any) {
            return $("<li>")
                .addClass("sps-autocomplete-item")
                .append(`<div class="sps-autocomplete-item-content">
                                        <span class="text">${item.label}</span>
                                   </div>`)
                .appendTo(ul);
        };
    }
}